import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { style: { "background-color": "#CCCCCC" } };
const _hoisted_2 = { class: "col-4 q-pa-sm" };
const _hoisted_3 = { class: "row items-center justify-end" };
const _hoisted_4 = { class: "col-8 q-pa-sm" };
const _hoisted_5 = { class: "col-4 q-pa-sm" };
const _hoisted_6 = { class: "col-8 q-pa-sm" };
const _hoisted_7 = {
    key: 0,
    class: "col-12 q-pa-sm"
};
const _hoisted_8 = { class: "col-4 q-pa-sm" };
const _hoisted_9 = {
    key: 1,
    class: "col-4 q-pa-sm"
};
const _hoisted_10 = {
    key: 2,
    class: "col-8 q-pa-sm"
};
const _hoisted_11 = {
    key: 3,
    class: "col-4 q-pa-sm"
};
const _hoisted_12 = {
    key: 4,
    class: "col-8 q-pa-sm"
};
const _hoisted_13 = {
    key: 5,
    class: "col-12 q-px-sm q-pt-sm"
};
const _hoisted_14 = { class: "line-break text-bold-red" };
const _hoisted_15 = { class: "text-caption text-red" };
const _hoisted_16 = {
    key: 6,
    class: "col-4 q-pa-sm"
};
const _hoisted_17 = { class: "q-gutter-md row items-start" };
const _hoisted_18 = { class: "row items-center justify-end" };
const _hoisted_19 = {
    key: 9,
    class: "col-4 q-pa-sm"
};
const _hoisted_20 = {
    key: 10,
    class: "col-4 q-pa-sm"
};
const _hoisted_21 = {
    key: 11,
    class: "col-4 q-pa-sm"
};
const _hoisted_22 = {
    key: 12,
    class: "col-4 q-pa-sm"
};
const _hoisted_23 = {
    key: 13,
    class: "col-8 q-pa-sm"
};
const _hoisted_24 = {
    key: 14,
    class: "col-4 q-pa-sm"
};
const _hoisted_25 = {
    key: 15,
    class: "col-8 q-pa-sm"
};
const _hoisted_26 = {
    key: 16,
    class: "col-4 q-pa-sm"
};
const _hoisted_27 = {
    key: 17,
    class: "col-8 q-pa-sm"
};
const _hoisted_28 = {
    key: 18,
    class: "col-4 q-pa-sm"
};
const _hoisted_29 = {
    key: 19,
    class: "col-4 q-pa-sm"
};
const _hoisted_30 = {
    key: 20,
    class: "col-4 q-pa-sm"
};
const _hoisted_31 = {
    key: 21,
    class: "col-12 q-pa-sm"
};
const _hoisted_32 = {
    key: 22,
    class: "col-8 q-pa-sm"
};
const _hoisted_33 = {
    key: 23,
    class: "col-12 q-pa-sm q-pb-lg"
};
const _hoisted_34 = { class: "row items-center q-gutter-sm" };
const _hoisted_35 = {
    class: "col rounded-borders",
    style: { "border": "1px solid #ccc", "min-height": "40px" }
};
const _hoisted_36 = { class: "q-px-md" };
const _hoisted_37 = {
    key: 24,
    class: "col-12 q-pa-sm"
};
const _hoisted_38 = { class: "row items-center q-gutter-sm" };
const _hoisted_39 = {
    class: "col rounded-borders",
    style: { "border": "1px solid #ccc", "min-height": "40px" }
};
const _hoisted_40 = { class: "q-px-md" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_date = _resolveComponent("q-date");
    const _component_q_popup_proxy = _resolveComponent("q-popup-proxy");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_select = _resolveComponent("q-select");
    const _component_q_time = _resolveComponent("q-time");
    const _component_q_file = _resolveComponent("q-file");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    const _directive_close_popup = _resolveDirective("close-popup");
    return (!_ctx.props.row.isDeleted)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["q-pa-sm", _ctx.isMultipleKeiyaku ? _ctx.$q.screen.lt.lg ? 'col-12' : 'col-6' : 'col-12'])
        }, [
            _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_q_card_section, { class: "row justify-between items-center" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.bukkenName) + " " + _toDisplayString(_ctx.props.row.roomNumber) + "（" + _toDisplayString(_ctx.props.row.nyukyosha) + "） ", 1),
                                (_ctx.isMultipleKeiyaku)
                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 0,
                                        name: "delete",
                                        color: "red",
                                        size: "2em",
                                        class: "cursor-pointer delete-icon",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.remove(_ctx.props.row.taikyoNo)))
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_section, { class: "row" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[42] || (_cache[42] = _createElementVNode("div", null, "退去予定日", -1)),
                                _createVNode(_component_q_input, {
                                    modelValue: _ctx.props.row.taikyoYmd,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.props.row.taikyoYmd) = $event)),
                                    color: "positive",
                                    outlined: "",
                                    "bottom-slots": "",
                                    dense: "",
                                    error: _ctx.getValidator(_ctx.props.row)?.taikyoYmd.error,
                                    "error-message": _ctx.getValidator(_ctx.props.row)?.taikyoYmd.message
                                }, {
                                    append: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                            name: "event",
                                            class: "cursor-pointer"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_popup_proxy, {
                                                    ref: "qDateProxy",
                                                    "transition-show": "scale",
                                                    "transition-hide": "scale"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_date, {
                                                            modelValue: _ctx.props.row.taikyoYmd,
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.props.row.taikyoYmd) = $event)),
                                                            color: "green-7"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_3, [
                                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                                        label: "閉じる",
                                                                        color: "green-7",
                                                                        flat: ""
                                                                    }, null, 512), [
                                                                        [_directive_close_popup]
                                                                    ])
                                                                ])
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                }, 512)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "error", "error-message"])
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[43] || (_cache[43] = _createElementVNode("div", null, "解約日", -1)),
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.kaiyakuYmd == null ? "" : _ctx.dayjs(_ctx.props.row.kaiyakuYmd ?? "").format("YYYY/MM/DD")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _cache[44] || (_cache[44] = _createElementVNode("div", null, "退去理由", -1)),
                                _createVNode(_component_q_select, {
                                    modelValue: _ctx.props.row.taikyoRiyuKb,
                                    "onUpdate:modelValue": [
                                        _cache[3] || (_cache[3] = ($event) => ((_ctx.props.row.taikyoRiyuKb) = $event)),
                                        _cache[4] || (_cache[4] = ($event) => (_ctx.clearTaikyoRiyu(_ctx.props.row)))
                                    ],
                                    options: _ctx.props.taikyoForInput.taikyoReasons,
                                    "option-label": 'label',
                                    "option-value": 'value',
                                    color: "positive",
                                    outlined: "",
                                    "bottom-slots": "",
                                    dense: "",
                                    "emit-value": "",
                                    "map-options": "",
                                    error: _ctx.getValidator(_ctx.props.row)?.taikyoRiyuKb.error,
                                    "error-message": _ctx.getValidator(_ctx.props.row)?.taikyoRiyuKb.message
                                }, null, 8, ["modelValue", "options", "error", "error-message"])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _cache[45] || (_cache[45] = _createElementVNode("div", null, "退去理由の詳細", -1)),
                                _createVNode(_component_q_input, {
                                    modelValue: _ctx.props.row.taikyoRiyu,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.props.row.taikyoRiyu) = $event)),
                                    outlined: "",
                                    "bottom-slots": "",
                                    dense: "",
                                    color: "positive",
                                    "bg-color": _ctx.viewModel.isRequiredTaikyoRiyu(_ctx.props.row) ? '' : 'grey-3',
                                    disable: _ctx.viewModel.isDisableTaikyoRiyu(_ctx.props.row),
                                    error: _ctx.getValidator(_ctx.props.row)?.taikyoRiyu.error,
                                    "error-message": _ctx.getValidator(_ctx.props.row)?.taikyoRiyu.message
                                }, null, 8, ["modelValue", "bg-color", "disable", "error", "error-message"])
                            ]),
                            (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb !== _ctx.KeyReturnNameKb.HandoverDate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _cache[46] || (_cache[46] = _createElementVNode("div", null, "その他ご契約事項", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.sonotaKeiyaku,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.props.row.sonotaKeiyaku) = $event)),
                                        type: "textarea",
                                        rows: "1",
                                        hint: "例）屋外駐車場2区画5番",
                                        color: "positive",
                                        outlined: "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.sonotaKeiyaku.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.sonotaKeiyaku.message
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_8, [
                                _cache[47] || (_cache[47] = _createElementVNode("div", null, "連絡先", -1)),
                                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "text-caption no-wrap" }, "※連絡先を選択してください。", -1)),
                                _createVNode(_component_q_select, {
                                    modelValue: _ctx.props.row.renrakuKb,
                                    "onUpdate:modelValue": [
                                        _cache[7] || (_cache[7] = ($event) => ((_ctx.props.row.renrakuKb) = $event)),
                                        _cache[8] || (_cache[8] = ($event) => (_ctx.clearRenrakuField(_ctx.props.row)))
                                    ],
                                    options: _ctx.props.taikyoForInput.contactKbList,
                                    "option-label": 'label',
                                    "option-value": 'value',
                                    color: "positive",
                                    "emit-value": "",
                                    "map-options": "",
                                    outlined: "",
                                    "bottom-slots": "",
                                    dense: "",
                                    clearable: "",
                                    "clear-icon": "close"
                                }, null, 8, ["modelValue", "options"])
                            ]),
                            _cache[72] || (_cache[72] = _createElementVNode("div", { class: "col-8 q-pa-sm" }, null, -1)),
                            (_ctx.props.row.renrakuKb === _ctx.RenrakuKb.Other)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _cache[49] || (_cache[49] = _createElementVNode("div", null, "氏名", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.renrakuName,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.props.row.renrakuName) = $event)),
                                        color: "positive",
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.renrakuName.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.renrakuName.message
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.renrakuKb === _ctx.RenrakuKb.Other)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _cache[50] || (_cache[50] = _createElementVNode("div", null, "入居者との関係性", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.renrakuRelationship,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.props.row.renrakuRelationship) = $event)),
                                        color: "positive",
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.renrakuRelationship.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.renrakuRelationship.message
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.renrakuKb !== null && [_ctx.RenrakuKb.Hojin, _ctx.RenrakuKb.Nyukyosha, _ctx.RenrakuKb.Other].includes(_ctx.props.row.renrakuKb))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _cache[51] || (_cache[51] = _createElementVNode("div", null, "電話番号", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.tel,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.props.row.tel) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.tel.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.tel.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.renrakuKb !== null && [_ctx.RenrakuKb.Hojin, _ctx.RenrakuKb.Nyukyosha, _ctx.RenrakuKb.Other].includes(_ctx.props.row.renrakuKb))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _cache[52] || (_cache[52] = _createElementVNode("div", null, "メールアドレス", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.email,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.props.row.email) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.email.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.email.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.PreferredAttendanceDatetime)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.desiredDateMessage), 1),
                                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.desiredDateEntryMessage), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isMMA)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnName), 1),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.keyReturnYmd,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.props.row.keyReturnYmd) = $event)),
                                        color: "positive",
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        "hide-bottom-space": "",
                                        error: _ctx.getValidator(_ctx.props.row)?.keyReturnYmd.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.keyReturnYmd.message
                                    }, {
                                        append: _withCtx(() => [
                                            _createVNode(_component_q_icon, {
                                                name: "event",
                                                class: "cursor-pointer"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_popup_proxy, {
                                                        ref: "selectDate",
                                                        "transition-show": "scale",
                                                        "transition-hide": "scale"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", null, [
                                                                _createElementVNode("div", _hoisted_17, [
                                                                    _createVNode(_component_q_date, {
                                                                        modelValue: _ctx.props.row.keyReturnStrYmd,
                                                                        "onUpdate:modelValue": [
                                                                            _cache[13] || (_cache[13] = ($event) => ((_ctx.props.row.keyReturnStrYmd) = $event)),
                                                                            _cache[14] || (_cache[14] = ($event) => (_ctx.applyDateTime(_ctx.props.row)))
                                                                        ],
                                                                        color: "green-7"
                                                                    }, null, 8, ["modelValue"]),
                                                                    (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb !== _ctx.KeyReturnNameKb.HandoverDate)
                                                                        ? (_openBlock(), _createBlock(_component_q_time, {
                                                                            key: 0,
                                                                            modelValue: _ctx.props.row.keyReturnStrTime,
                                                                            "onUpdate:modelValue": [
                                                                                _cache[15] || (_cache[15] = ($event) => ((_ctx.props.row.keyReturnStrTime) = $event)),
                                                                                _cache[16] || (_cache[16] = ($event) => (_ctx.applyDateTime(_ctx.props.row)))
                                                                            ],
                                                                            color: "green-7",
                                                                            "minute-options": [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
                                                                            rules: ['rule']
                                                                        }, null, 8, ["modelValue"]))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _createElementVNode("div", _hoisted_18, [
                                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                                        label: "閉じる",
                                                                        color: "green-7",
                                                                        flat: ""
                                                                    }, null, 512), [
                                                                        [_directive_close_popup]
                                                                    ])
                                                                ])
                                                            ])
                                                        ]),
                                                        _: 1
                                                    }, 512)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isMMA)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 7,
                                    class: "col-4 q-pa-sm",
                                    style: _normalizeStyle({ visibility: _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb !== _ctx.KeyReturnNameKb.HandoverDate ? 'visible' : 'hidden' })
                                }, [
                                    _cache[53] || (_cache[53] = _createElementVNode("div", null, "鍵返却予定数", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.numberOfReturnKeys,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.props.row.numberOfReturnKeys) = $event)),
                                        color: "positive",
                                        type: "number",
                                        outlined: "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.numberOfReturnKeys.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.numberOfReturnKeys.message
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ], 4))
                                : _createCommentVNode("", true),
                            (!_ctx.isMMA)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 8,
                                    class: "col-4 q-pa-sm",
                                    style: _normalizeStyle([{ "padding-right": "0" }, { visibility: _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.KeyReturnScheduledDatetime ? 'visible' : 'hidden' }])
                                }, [
                                    _cache[54] || (_cache[54] = _createElementVNode("div", null, "鍵返却予定店舗", -1)),
                                    _createElementVNode("div", null, _toDisplayString(_ctx.props.row.shopName), 1),
                                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "text-caption" }, "※こちらの店舗に鍵を返却してください。", -1))
                                ], 4))
                                : _createCommentVNode("", true),
                            (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.PreferredAttendanceDatetime && !_ctx.isMMA)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _cache[56] || (_cache[56] = _createElementVNode("div", null, "退去立会者", -1)),
                                    _createVNode(_component_q_select, {
                                        modelValue: _ctx.props.row.taikyoTachiaiKb,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.props.row.taikyoTachiaiKb) = $event)),
                                        options: _ctx.props.taikyoForInput.tachiaishaKbnList,
                                        "option-label": 'label',
                                        "option-value": 'value',
                                        color: "positive",
                                        outlined: "",
                                        "bottom-slots": "",
                                        "emit-value": "",
                                        "map-options": "",
                                        dense: "",
                                        clearable: "",
                                        "clear-icon": "close"
                                    }, null, 8, ["modelValue", "options"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.PreferredAttendanceDatetime && !_ctx.isMMA)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _cache[57] || (_cache[57] = _createElementVNode("div", null, "退去立会者名", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.taikyoTachiaiName,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.props.row.taikyoTachiaiName) = $event)),
                                        color: "positive",
                                        outlined: "",
                                        dense: "",
                                        error: _ctx.getValidator(_ctx.props.row)?.taikyoTachiaiName.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.taikyoTachiaiName.message
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.PreferredAttendanceDatetime)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                                : _createCommentVNode("", true),
                            (![_ctx.KeyReturnNameKb.HandoverDate, _ctx.KeyReturnNameKb.PreferredAttendanceDatetime].includes(_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb ?? -1))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _cache[58] || (_cache[58] = _createElementVNode("div", null, "鍵封筒送付先", -1)),
                                    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "text-caption no-wrap" }, "※送付先を選択してください。", -1)),
                                    _cache[60] || (_cache[60] = _createElementVNode("div", { class: "text-caption no-wrap" }, "※電子錠の方は、その他を選択し「送付不要」と入力してください。", -1)),
                                    _createVNode(_component_q_select, {
                                        modelValue: _ctx.props.row.keyReturnAdrKb,
                                        "onUpdate:modelValue": [
                                            _cache[21] || (_cache[21] = ($event) => ((_ctx.props.row.keyReturnAdrKb) = $event)),
                                            _cache[22] || (_cache[22] = ($event) => (_ctx.clearSoufuField(_ctx.props.row)))
                                        ],
                                        options: _ctx.props.taikyoForInput.contactKbList,
                                        "option-label": 'label',
                                        "option-value": 'value',
                                        color: "positive",
                                        "emit-value": "",
                                        "map-options": "",
                                        outlined: "",
                                        "bottom-slots": "",
                                        dense: "",
                                        clearable: "",
                                        "clear-icon": "close"
                                    }, null, 8, ["modelValue", "options"])
                                ]))
                                : _createCommentVNode("", true),
                            (![_ctx.KeyReturnNameKb.HandoverDate, _ctx.KeyReturnNameKb.PreferredAttendanceDatetime].includes(_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb ?? -1))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _cache[61] || (_cache[61] = _createElementVNode("div", null, "氏名", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.soufuName,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.props.row.soufuName) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.soufuName.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.soufuName.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _cache[62] || (_cache[62] = _createElementVNode("div", null, "郵便番号", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.postCode,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.props.row.postCode) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.postCode.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.postCode.message,
                                        dense: "",
                                        outlined: "",
                                        onBlur: _cache[25] || (_cache[25] = ($event) => (_ctx.findAddress(_ctx.props.row)))
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _cache[63] || (_cache[63] = _createElementVNode("div", null, "県市区町村", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.adr1,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.props.row.adr1) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.adr1.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.adr1.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _cache[64] || (_cache[64] = _createElementVNode("div", null, "番地", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.adr2,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.props.row.adr2) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.adr2.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.adr2.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Hojin || _ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Nyukyosha)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _cache[65] || (_cache[65] = _createElementVNode("div", null, "建物名号室", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.adr3,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.props.row.adr3) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.adr3.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.adr3.message,
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Other)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _cache[66] || (_cache[66] = _createElementVNode("div", null, "自由記入", -1)),
                                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "text-caption no-wrap" }, "※住所を入力の際は、必ず「郵便番号」を入力してください。", -1)),
                                    _createVNode(_component_q_input, {
                                        modelValue: _ctx.props.row.soufuSonota,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_ctx.props.row.soufuSonota) = $event)),
                                        color: "positive",
                                        error: _ctx.getValidator(_ctx.props.row)?.soufuSonota.error,
                                        "error-message": _ctx.getValidator(_ctx.props.row)?.soufuSonota.message,
                                        label: "送付先・連絡方法など（自由記入）",
                                        dense: "",
                                        outlined: ""
                                    }, null, 8, ["modelValue", "error", "error-message"])
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.props.row.keyReturnAdrKb === _ctx.KeyReturnAdrKb.Other)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                                : _createCommentVNode("", true),
                            (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === _ctx.KeyReturnNameKb.KeyReturnScheduledDatetime)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _cache[68] || (_cache[68] = _createElementVNode("div", null, "破損・汚損申告", -1)),
                                    _createElementVNode("div", _hoisted_34, [
                                        _createVNode(_component_q_btn, {
                                            icon: "save",
                                            color: "green-7",
                                            onClick: _cache[30] || (_cache[30] = ($event) => (_ctx.openDialogHason()))
                                        }),
                                        _createElementVNode("div", _hoisted_35, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.row.fileList.filter(x => x.fileKb === 0 && x.delFlg === false), (file) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: file.fileId,
                                                    class: "row items-center q-gutter-sm",
                                                    borderlice: ""
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(file.fileName), 1),
                                                    _createVNode(_component_q_btn, {
                                                        icon: "close",
                                                        flat: "",
                                                        round: "",
                                                        dense: "",
                                                        onClick: ($event) => (_ctx.fileDelete(file))
                                                    }, null, 8, ["onClick"])
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(_component_q_dialog, {
                                modelValue: _ctx.dialogOpenHason,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((_ctx.dialogOpenHason) = $event)),
                                persistent: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_card, { style: { "min-width": "40vw" } }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_card_section, { class: "q-gutter-md" }, {
                                                default: _withCtx(() => [
                                                    _cache[69] || (_cache[69] = _createElementVNode("div", { class: "q-px-md" }, [
                                                        _createElementVNode("div", {
                                                            class: "text-h5",
                                                            style: { "font-weight": "bold" }
                                                        }, "破損・汚損情報"),
                                                        _createElementVNode("ul", null, [
                                                            _createElementVNode("li", { class: "text-subtitle2" }, "本申告書記載の金額と賃貸借契約書の「故意過失による破損・汚損単申告書（単価表）」が相違している場合は、金額の低い方で精算を行います。"),
                                                            _createElementVNode("li", { class: "text-subtitle2" }, "上記金額は、目安金額であり退去後別途見積りとなる場合があります。"),
                                                            _createElementVNode("li", { class: "text-subtitle2" }, "上記に記載の無い項目については、退去後別途見積りとなります。"),
                                                            _createElementVNode("li", { class: "text-subtitle2" }, "通常のクリーニングでは除去できない程度のたばこのヤニ汚れや、結露を放置したことにより拡大した壁面、床等のカビ・シミ等の汚れは借主の故意過失による汚損になります。")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_36, [
                                                        _createVNode(_component_q_file, {
                                                            modelValue: _ctx.tmpFile,
                                                            "onUpdate:modelValue": [
                                                                _cache[31] || (_cache[31] = ($event) => ((_ctx.tmpFile) = $event)),
                                                                _cache[32] || (_cache[32] = ($event) => (_ctx.onFilePicked(_ctx.tmpFile, _ctx.props.row)))
                                                            ],
                                                            outlined: "",
                                                            dense: "",
                                                            "use-chips": "",
                                                            label: "ファイル選択",
                                                            accept: ".pdf"
                                                        }, {
                                                            append: _withCtx(() => [
                                                                _createVNode(_component_q_icon, { name: "file_upload" })
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue"])
                                                    ])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_q_card_actions, { align: "right" }, {
                                                default: _withCtx(() => [
                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                        flat: "",
                                                        label: "閉じる",
                                                        color: "grey-7",
                                                        onClick: _cache[33] || (_cache[33] = ($event) => (_ctx.tmpFile = []))
                                                    }, null, 512), [
                                                        [_directive_close_popup]
                                                    ]),
                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                        flat: "",
                                                        label: "確定",
                                                        color: "green-7",
                                                        disable: _ctx.tmpFile.length === 0 || _ctx.props.row.fileList.filter(x => x.fileKb === 0 && x.delFlg === false).length === 1 || _ctx.errorFlg,
                                                        onClick: _cache[34] || (_cache[34] = ($event) => (_ctx.uploadFile(_ctx.tmpFile, _ctx.props.row, 0)))
                                                    }, null, 8, ["disable"]), [
                                                        [_directive_close_popup]
                                                    ])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"]),
                            (!_ctx.isMMA)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _cache[70] || (_cache[70] = _createElementVNode("div", null, "破損・汚損以外の添付ファイル", -1)),
                                    _createElementVNode("div", _hoisted_38, [
                                        _createVNode(_component_q_btn, {
                                            icon: "save",
                                            color: "green-7",
                                            onClick: _cache[36] || (_cache[36] = ($event) => (_ctx.openDialogOther()))
                                        }),
                                        _createElementVNode("div", _hoisted_39, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.row.fileList.filter(x => x.fileKb === 1 && x.delFlg === false), (file) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: file.fileId,
                                                    class: "row items-center q-gutter-sm"
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(file.fileName), 1),
                                                    _createVNode(_component_q_btn, {
                                                        icon: "close",
                                                        flat: "",
                                                        round: "",
                                                        dense: "",
                                                        onClick: ($event) => (_ctx.fileDelete(file))
                                                    }, null, 8, ["onClick"])
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(_component_q_dialog, {
                                modelValue: _ctx.dialogOpenOther,
                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((_ctx.dialogOpenOther) = $event)),
                                persistent: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_card, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_card_section, { class: "q-gutter-md" }, {
                                                default: _withCtx(() => [
                                                    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "q-px-md" }, [
                                                        _createElementVNode("div", {
                                                            class: "text-h5",
                                                            style: { "font-weight": "bold" }
                                                        }, "その他（ファイル）"),
                                                        _createElementVNode("ul", null, [
                                                            _createElementVNode("li", { class: "text-subtitle2" }, "一度にアップロードできるファイルは、最大10件です。"),
                                                            _createElementVNode("li", { class: "text-subtitle2" }, "アップロード可能なファイル形式は、JPG、JPEG、PNG、PDFです。")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_40, [
                                                        _createVNode(_component_q_file, {
                                                            modelValue: _ctx.tmpFile,
                                                            "onUpdate:modelValue": [
                                                                _cache[37] || (_cache[37] = ($event) => ((_ctx.tmpFile) = $event)),
                                                                _cache[38] || (_cache[38] = ($event) => (_ctx.onFilePicked(_ctx.tmpFile, _ctx.props.row)))
                                                            ],
                                                            outlined: "",
                                                            dense: "",
                                                            "use-chips": "",
                                                            multiple: "",
                                                            label: "ファイル選択",
                                                            accept: ".jpg, .jpeg, .png, .pdf"
                                                        }, {
                                                            append: _withCtx(() => [
                                                                _createVNode(_component_q_icon, { name: "file_upload" })
                                                            ]),
                                                            _: 1
                                                        }, 8, ["modelValue"])
                                                    ])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_q_card_actions, { align: "right" }, {
                                                default: _withCtx(() => [
                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                        flat: "",
                                                        label: "閉じる",
                                                        color: "grey-7",
                                                        onClick: _cache[39] || (_cache[39] = ($event) => (_ctx.tmpFile = []))
                                                    }, null, 512), [
                                                        [_directive_close_popup]
                                                    ]),
                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                        flat: "",
                                                        label: "確定",
                                                        color: "green-7",
                                                        disable: _ctx.tmpFile.length === 0 || _ctx.props.row.fileList.filter(x => x.fileKb === 1 && x.delFlg === false).length + _ctx.tmpFile.length > 10 || _ctx.errorFlg,
                                                        onClick: _cache[40] || (_cache[40] = ($event) => (_ctx.uploadFile(_ctx.tmpFile, _ctx.props.row, 1)))
                                                    }, null, 8, ["disable"]), [
                                                        [_directive_close_popup]
                                                    ])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ], 2))
        : _createCommentVNode("", true);
}
